import moment from "moment-timezone";
import { Label } from "@/components/ui/label";
import { Combobox } from "@/components/ui/combobox";
import { CommonDestinationTimezone } from "@/lib/utils";
import { SelectOptionItem } from "@/lib/models/ui";

const CROP_YEAR_OPTION_COUNT = 10;
const CROP_YEAR_START_OFFSET = 3;

interface CropYearFieldProps {
  value: string;
  error?: string;
  onChange: (v: string) => void;
}

export function CropYearField({ value, error, onChange }: CropYearFieldProps) {
  const currentYear = parseInt(moment.tz(CommonDestinationTimezone).format("YYYY"));
  const options: SelectOptionItem<string>[] = Array.from({ length: CROP_YEAR_OPTION_COUNT }, (_, i) => {
    const year = currentYear - i + CROP_YEAR_START_OFFSET;
    return { value: year.toString(), label: year.toString() };
  });

  return (
    <div className="flex flex-col gap-1">
      <Label>
        Crop Year <span className="text-destructive">*</span>
      </Label>
      <div>
        <Combobox
          dwimOnChange
          isModal={false}
          placeholder="Select crop year..."
          options={options}
          value={value}
          onValueChange={onChange}
        />
      </div>
      {error && <p className="text-destructive text-xs">{error}</p>}
    </div>
  );
}
